module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-appbar', {
    staticStyle: {
      "height": "0.8rem",
      "color": "black",
      "background-color": "#FFFFFF",
      "box-shadow": "1px 4px 90' 20%",
      "position": "fixed",
      "top": "0%",
      "max-width": "7.5rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40%",
      "float": "left",
      "margin-top": "0.3rem",
      "margin-bottom": "0.1rem"
    },
    attrs: {
      "src": require("../../../static/Brand/Main/logoNEW_1.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:4006-998-998"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "48%",
      "float": "right",
      "margin-top": "0.8rem",
      "margin-right": "0.0rem"
    },
    attrs: {
      "src": require("../../../static/Brand/Main/telephone.png")
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#FFFFFF",
      "margin-bottom": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "title1"
  }, [_vm._v("格林酒店 诚邀加盟")]), _vm._v(" "), _c('div', {
    staticClass: "title2",
    staticStyle: {
      "color": "#363636"
    }
  }, [_vm._v("加盟热线4006-998-988转6")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#a6a4a4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "姓名*"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserPhone),
      expression: "UserPhone"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#a6a4a4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "电话*"
    },
    domProps: {
      "value": (_vm.UserPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticStyle: {
      "letter-spacing": "0.1rem",
      "width": "90%",
      "height": "0.8rem",
      "background-color": "#36c27b",
      "border-radius": "4px",
      "border-width": "0",
      "font-size": "18px",
      "color": "#f5f5f5",
      "margin-top": "0.13rem"
    },
    attrs: {
      "type": "button",
      "value": "立即留言"
    },
    on: {
      "click": _vm.message
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("加盟优势")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "3.5%",
      "margin-right": "3.5%",
      "width": "100%"
    }
  }, [(_vm.ShowText1 == '11') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(12)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/1.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText1 == '12') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(11)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/1.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText2 == '21') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(22)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/2.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText2 == '22') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(21)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/2.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText3 == '31') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(32)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/3.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText3 == '32') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(31)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/3.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText4 == '41') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(42)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/4.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText4 == '42') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(41)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/4.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText5 == '51') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(52)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/5.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText5 == '52') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(51)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/5.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText6 == '61') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(62)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/6.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText6 == '62') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(61)
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/6.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText7 == '71') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(72)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/7.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText7 == '72') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(71)
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/7.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText8 == '81') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(82)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/8.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText8 == '82') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(81)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/8.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText9 == '91') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(92)
      }
    }
  }, [_c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/9.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowText9 == '92') ? _c('div', {
    staticClass: "advantageitem",
    staticStyle: {
      "float": "left",
      "margin-left": "1.5%"
    },
    on: {
      "click": function($event) {
        return _vm.clickIcon(91)
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('img', {
    staticStyle: {},
    attrs: {
      "src": require("../../../static/Brand/Main/9.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#363636",
      "font-size": "0.4rem",
      "margin-top": "0.5rem",
      "font-weight": "bold",
      "margin-bottom": "0.5rem",
      "border-bottom": "2px solid #36C27B",
      "width": "2.4rem"
    }
  }, [_vm._v("酒店品牌介绍")]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.brands2), function(item) {
    return _c('swiper-slide', [_c('img', {
      attrs: {
        "src": item.url
      },
      on: {
        "click": function($event) {
          return _vm.BrandGoto(item.pathstr)
        }
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.2rem",
      "text-align": "left"
    }
  }, [_vm._v("※左右划动了解酒店品牌加盟详情")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1",
      "margin-top": "0.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#FFFFFF",
      "margin-bottom": "1.5rem"
    },
    attrs: {
      "id": "bottomMessage"
    }
  }, [_c('div', {
    staticClass: "title1"
  }, [_vm._v("格林酒店 诚邀加盟")]), _vm._v(" "), _c('div', {
    staticClass: "title2",
    staticStyle: {
      "color": "#363636"
    }
  }, [_vm._v("加盟热线4006-998-988转6")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "姓名*"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "电话*"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "城市"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "留言"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticStyle: {
      "letter-spacing": "0.1rem",
      "width": "90%",
      "height": "0.8rem",
      "background-color": "#36c27b",
      "border-radius": "4px",
      "border-width": "0",
      "font-size": "18px",
      "color": "#f5f5f5",
      "margin-top": "0.13rem"
    },
    attrs: {
      "type": "button",
      "value": "提交留言"
    },
    on: {
      "click": _vm.post
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "buttonText",
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#999999"
    }
  }, [_vm._v("格林豪泰酒店（中国）有限公司版权所有")]), _vm._v(" "), _c('div', {
    staticClass: "buttonText",
    staticStyle: {
      "font-size": "0.1rem",
      "color": "#999999"
    }
  }, [_vm._v("投资有风险，选择需谨慎")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../static/Brand/Main/top2_1.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("集团简介")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.29rem",
      "margin-left": "0.2rem",
      "margin-right": "0.2rem",
      "text-align": "justify",
      "text-justify": "inter-ideograph"
    }
  }, [_vm._v("格林酒店集团（原格林豪泰酒店管理集团）2018年3月登陆纽交所（NYSE:GHG），是中国领先的酒店管理集团公司。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.29rem",
      "margin-left": "0.2rem",
      "margin-right": "0.2rem",
      "text-align": "justify",
      "margin-top": "0.3rem",
      "text-justify": "inter-ideograph"
    }
  }, [_vm._v("2004年创立至今，格林酒店集团在中国340多个城市拥有5000多家酒店（含筹建），超过30万间客房，酒店规模位居全球和中国前列。通过始终如一的服务质量、标志性的酒店设计和广泛的地理布局，集团打造了格林东方、格美、格雅、格菲、无眠、格林豪泰、格盟、格林公寓、青皮树、贝壳、雅阁、澳斯特、都市花园、都市118精选、青年·都市迷你等优质品牌，覆盖高端、中高端、中端以及经济型酒店市场，为合作伙伴和客人提供多元化选择。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.29rem",
      "margin-left": "0.2rem",
      "margin-right": "0.2rem",
      "text-align": "justify",
      "margin-top": "0.3rem",
      "text-justify": "inter-ideograph"
    }
  }, [_vm._v("依托母公司格美集团（KOSMOS GROUP）在餐饮、数据智造领域的多元布局，格林酒店集团不仅为客人提供全方位的住宿和餐饮服务，还为合作伙伴打造了多元化的投资平台。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("综合成本仅为同类品牌的"), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("一半")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("优异酒店投资回报率接近"), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("100%")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("160")]), _vm._v("万高质量企业客户"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("5000")]), _vm._v("万会员及商旅客户推荐\r\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("官网:www."), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("998")]), _vm._v(".com"), _c('br'), _vm._v("电话:4006-"), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("998")]), _vm._v("-"), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("998")]), _c('br'), _vm._v("微信/手机APP搜索["), _c('span', {
    staticStyle: {
      "color": "#E95341",
      "font-size": "0.25rem"
    }
  }, [_vm._v("格林")]), _vm._v("]")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("融合地方特色建筑风格与文化特色，酒店外观经久不衰，客房布置现代实用，设计匠心独运")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("集团自主PMS系统连接订房、购物\r\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("定制管理学院，成熟的连锁管理模式和经验的管理团队\r\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("聚集各行业精英及国际酒店管理经验为您保驾护航")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('div', {
    staticClass: "shadetext"
  }, [_c('div', {
    staticClass: "shadediv"
  }, [_vm._v("联合银行等金融机构对特定的投资人给予融资扶持")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-bottom-nav mu-bottom-nav-shift",
    staticStyle: {
      "position": "fixed",
      "bottom": "0%",
      "user-select": "none",
      "cursor": "pointer",
      "-webkit-appearance": "none",
      "-webkit-box-shadow": "#000000 1px 4px 6px",
      "-moz-box-shadow": "#000000 1px 4px 6px",
      "box-shadow": "#000000 1px 4px 6px",
      "background": "#FFFFFF",
      "z-index": "9999"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "0.3rem",
      "color": "#4B4B4B",
      "margin-right": "1rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:4006-998-998"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "src": require("../../../static/Brand/Main/tel.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "float": "right",
      "color": "#363636"
    }
  }, [_vm._v(" 电话咨询  ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "0.3rem",
      "color": "#4B4B4B"
    }
  }, [_c('a', {
    attrs: {
      "href": "#bottomMessage"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "src": require("../../../static/Brand/Main/message.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "float": "right",
      "color": "#363636"
    }
  }, [_vm._v("  在线留言   ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a2a5fcc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrandDetails/BrandIndex.vue
// module id = 1470
// module chunks = 18